import { useMemo } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { useUrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import { toDonationApprovalFilterSearch, toDonationApprovalFilterValues } from '../utils/mpFilters';

const ROUTES = {
  approvalReport: getRouteApi('/_auth/market-promotion/approval-report'),
  cashCollection: getRouteApi('/_auth/market-promotion/cash-collection'),
} as const;

export type ApprovalReportRouteId = keyof typeof ROUTES;

const normalizeFilterValues = (values: Record<string, string>) =>
  toDonationApprovalFilterValues(toDonationApprovalFilterSearch(values), undefined);

export function useApprovalReportFilters(routeId: ApprovalReportRouteId) {
  const route = ROUTES[routeId];
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const appliedValues = useMemo(() => toDonationApprovalFilterValues(search, undefined), [search]);

  const filters = useUrlSyncedFilters({
    appliedValues,
    normalizeValues: normalizeFilterValues,
    onApply: (values) => {
      void navigate({
        search: (previous) => ({ ...previous, ...toDonationApprovalFilterSearch(values) }),
        replace: true,
      });
    },
  });

  return { ...filters, search };
}
